import getAllFocusableDescendents from '../getAllFocusableDescendents';
import isElementHidden from '../isElementHidden';

var getAllTabbableDescendents = function getAllTabbableDescendents(element) {
  var focusableElements = getAllFocusableDescendents(element);
  return Array.from(focusableElements).filter(function (el) {
    return !isElementHidden(el);
  });
};

export default getAllTabbableDescendents;